import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=48457dbc&scoped=true"
import script from "./UserAccess.vue?vue&type=script&lang=js"
export * from "./UserAccess.vue?vue&type=script&lang=js"
import style0 from "./UserAccess.vue?vue&type=style&index=0&id=48457dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48457dbc",
  null
  
)

export default component.exports